export enum GoogleAnalyticsCustomerJourney {
  Inspiration = 'Inspiration',
  Consideration = 'Consideration',
  Interest = 'Interest',
}
